// src/app/shared/validators/custom-validators.ts
import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

export class CustomValidators {
  static phone(control: AbstractControl): ValidationErrors | null {
    const phoneRegex = /^\(\d{2}\) \d{4,5}-\d{4}$/;
    const value = control.value;

    if (!value) {
      return null; // Allow empty values (required validator will handle that)
    }

    if (!phoneRegex.test(value)) {
      return { phone: true };
    }

    return null;
  }

  static ratingRange(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
      return null; // Deixe o Validators.required cuidar de valores vazios
    }

    // Remover qualquer coisa que não seja dígito (para o caso de type="phone" permitir algo)
    const cleanedValue = String(value).replace(/\D/g, '');

    // Verificar se a string resultante é vazia ou contém algo que não seja um número inteiro
    if (!/^\d+$/.test(cleanedValue)) {
      return {
        ratingRange: true,
        message: 'A nota deve ser um número inteiro.',
      };
    }

    const numValue = parseInt(cleanedValue, 10);

    if (isNaN(numValue)) {
      return {
        ratingRange: true,
        message: 'A nota deve ser um número válido.',
      };
    }

    // Verificar se está no range de 1 a 10
    if (numValue < 1 || numValue > 10) {
      return { ratingRange: true, message: 'A nota deve ser entre 1 e 10.' };
    }

    return null;
  }
}
